import React from "react";
import { useTable } from "hooks";
import { Page } from "components/common";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";
import StartSession from "components/StartSession";

export const List = ({ match }) => {
  const {
    Pagination,
    ViewingRecords,
    TableContainer,
    TableSearch,
    TableDataFetch,
    data,
    AddNewButton,
    BulkDeleteButton,
    refreshData,
  } = useTable({
    match,
    url: "groups",
    resource: "Group",
  });

  return (
    <Page title="Groups">
      <TableSearch className="fa-min" />
      <div className="tw-flex tw-mb-3 tw-items-start tw-flex-wrap">
        <AddNewButton />
        <div className="tw-mx-auto" />
        <BulkDeleteButton />
      </div>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th select />
              <th sortBy="name">Name</th>
              <th>Registered</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.results.map((i) => (
              <tr key={i.id}>
                <td select />
                <td>
                  <Link to={`${match.url}/${i.id}`}>{i.name}</Link>
                </td>
                <td>{i.num_registered}</td>
                <td className="tw-text-right">
                  <StartSession
                    groupId={i.id}
                    size="sm"
                    onBulkCreated={refreshData}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <div className="tw-flex tw-justify-between">
        <ViewingRecords />
        <Pagination />
      </div>
      <TableDataFetch />
    </Page>
  );
};

export default List;
